import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { OrdersetCategoryTestSelection } from './components'
import { useOrdersetSettingsPageBusinessLogic } from '../../../../../logic/context'
import { CompendiumPanelWithGuid } from '../../EditOrderset'
import { CompendiumPanelWithType } from '../../../../../types'

const OrdersetCategoryLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  border: 1px solid #e5e5e5;
  width: 100%;
  margin-top: 10px;
  padding: 20px;
  gap: 10px;
  align-items: center;
  align-content: center;
`
export interface OrdersetCategoryProps {
  category: CompendiumPanelWithGuid
  allCategories: CompendiumPanelWithGuid[]
  handleOrdersetCategoryChange: React.Dispatch<React.SetStateAction<any>>
}

export const OrdersetCategory = (props: OrdersetCategoryProps) => {
  const { category, allCategories, handleOrdersetCategoryChange } = props

  const pageLogic = useOrdersetSettingsPageBusinessLogic()

  const [selectedTests, setSelectedTests] = useState<CompendiumPanelWithType[]>([])

  useEffect(() => {
    const { panels } = category
    const existingGroupTests = panels?.map((test) => ({
      name: test.name,
      code: test.code,
      tests: test.tests,
      price: test.price,
      retail_price: test.retail_price,
      contract_price: test.contract_price,
      type: 'group',
    })) as unknown as CompendiumPanelWithType[]

    setSelectedTests(existingGroupTests)
  }, [])

  const handleSaveEditOrdersetCategoryClick = (groupTests: CompendiumPanelWithType[], individualTests: CompendiumPanelWithType[]) => {
    const finalGroupTests = groupTests.map((test) => ({
      type: 'group',
      tests: test.tests.map((t) => {
        return t?._id
      }),
    }))
    const finalIndividualTests = individualTests.map((test) => ({
      type: 'individual',
      tests: test.tests.map((t) => {
        return t?._id
      }),
    }))

    const categoryPayload = {
      id: category.id,
      category_id: category.category_id,
      panels: [...finalGroupTests, ...finalIndividualTests],
    }

    const updatedAllCategories = allCategories.map((cat) => {
      if (cat.id === category.id) {
        return categoryPayload
      }
    })

    handleOrdersetCategoryChange(updatedAllCategories)
  }

  return (
    <OrdersetCategoryLayout>
      <OrdersetCategoryTestSelection
        selectedTests={selectedTests}
        handleSelectedTestsChange={setSelectedTests}
        handleSaveEditOrdersetCategoryClick={handleSaveEditOrdersetCategoryClick}
      />
    </OrdersetCategoryLayout>
  )
}
